import React from 'react'
// import StagesManager from '../../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

import { nanoid } from 'nanoid';
import { checkTextTranslation, checkTranslation, imageAddress, translate } from '../../utils/useful';
// import HttpServices from '../utils/Http.services'



class SearchMain extends React.Component {
    state = {
        // sponsored:[
        //     {name:'Renovation Specialist - Property Buying & Selling', description:'With 30+ years of real estate experience, Harry Maisel specializes in luxury properties. Call The Harry Maisel Group today to find your dream property in the Chicagoland area!'},
        //     {name:'Open Real Estate - homes for sale by owner', description:'Place Your Order Today, Your Contribution Is Needed To Raise Funding For A Lupus Cure'}
        // ],
        // ad:[
        //     {name:'Renovation Specialist - Property Buying & Selling', description:'With 30+ years of real estate experience, Harry Maisel specializes in luxury properties. Call The Harry Maisel Group today to find your dream property in the Chicagoland area!'},
        //     {name:'Open Real Estate - homes for sale by owner', description:'Place Your Order Today, Your Contribution Is Needed To Raise Funding For A Lupus Cure'}
        // ],
        // search: [
        //     { label: 'Ad.', fullname: 'Ruben Mango', description: 'description', image: '/assets/icons/rooms/peoples/person4.svg' },
        //     { label: 'Ad.', fullname: 'Leo Herwitz', description: 'description', image: '/assets/icons/rooms/peoples/person5.svg' },
        //     { fullname: 'Paityn Carder', description: 'description', image: '/assets/icons/rooms/peoples/person2.svg' },

        // ]
    }
    componentDidMount() {

    }

    addWindow = (item, type) => {

        if (type == 'hub') {
            this.openHub(item)
        }
        if (type == 'applet') {
            this.openApplet(item)
        }
    }


    openHub = (item) => {
        this.props.addNewWindow("hub", { path: [item?.username], type: 'hub' }, "center")
        this.props.addToSearchHistory({ type: 'hub', hub: item._id })

    }

    openApplet = (item) => {

        this.props.addNewWindow("applet", { path: [item?.hub?.username, item?.slug], type: 'applet' }, "center")
        this.props.addToSearchHistory({ type: 'applet', applet: item._id })

    }


    render() {


        return (

            <div>

                <div className='br-10 bg-white box-shadow-20 mx-4 mb-4 pb-3'>
                    <div className='px-3 text-semibold pt-3 mb-2 text-normal'>
                        <p>{translate("Your licensed hubs")}</p>
                    </div>
                    {Array.isArray(this.props.licencedHubs) && this.props.licencedHubs.map((item, index) => {
                        return (
                            <div className='px-2' style={{}}>

                                <div className='' style={{ cursor: 'pointer', }} onClick={() => { this.addWindow(item.targetHub, 'hub') }}>
                                    <div className='w-100'>
                                        <div className='flexc pld-3'>
                                            <img src={imageAddress(item?.targetHub?.image, 'profile', 'small')} style={{ width: '35px', height: '35px', borderRadius: 40, objectFit: 'cover' }} className='mrd-3' />
                                            <div className='py-2 flex-1' style={{ borderBottom: '0px solid #eee' }}>
                                                <p className="font-size-14 main-c2 weight-500" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.targetHub?.fullname)}</p>
                                                <p className="font-size-12 main-c7" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{'@' + item?.targetHub?.username}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='flexc'>

                                <div className="position-relative">
                                    <div className="flexcc" style={{ backgroundColor: '#00000010', borderRadius: 30, width: '40px', height: '40px', }}>
                                        <img src={item.img} style={{ width: '36px', height: '36px', objectFit: 'cover', objectFit: "cover" }} alt='' />
                                    </div>
                                </div>

                                <div className='pld-4' style={{ width: `calc(100% - 50px)` }}>
                                    <div className='w-100 flexcb'>
                                        <p className='font-size-14 gradient-text weight-500' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{item.name}</p>
                                        {item.label &&
                                            <div className=' flexcc' style={{ backgroundColor: '#eee', borderRadius: 50, padding: 6 }}>
                                                <p className='font-size-12 weight-600' style={{ color: '#727272' }}>{item.label}</p>
                                            </div>
                                        }
                                    </div>
                                    <p className='font-size-12' style={{ color: '#777', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>@{item.name}</p>
                                </div>
                            </div> */}
                            </div>
                        )
                    })
                    }

                </div>



                <div className='br-10 bg-white box-shadow-20 mx-4 pb-3'>
                    <div className='px-3 text-semibold pt-3 mb-2 text-normal'>
                        <p>{translate("Search history")}</p>
                    </div>
                    {Array.isArray(this.props.searchHistory) && this.props.searchHistory.map((item, index) => {

                        return (
                            <div className='px-2' style={{}}>
                                {item.type == 'hub' && (
                                    <div className='' style={{ cursor: 'pointer', }} onClick={() => { this.addWindow(item.targetHub, 'hub') }}>
                                        <div className='w-100'>
                                            <div className='flexc pld-3'>
                                                <img src={imageAddress(item?.targetHub?.image, 'profile', 'small')} style={{ width: '35px', height: '35px', borderRadius: 40, objectFit: 'cover' }} className='mrd-3' />
                                                <div className='py-2 flex-1' style={{ borderBottom: '0px solid #eee' }}>
                                                    <p className="font-size-14 main-c2 weight-500" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.targetHub?.fullname)}</p>
                                                    <p className="font-size-12 main-c7" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{'@' + item?.targetHub?.username}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}


                                {item.type == 'applet' && (
                                    <div className='' style={{ cursor: 'pointer', }} onClick={() => { this.addWindow(item.targetApplet,'applet') }}>
                                        <div className='w-100'>
                                            <div className='flexc pld-3'>
                                                <img src={imageAddress(item?.targetApplet?.image, 'applet', 'small')} style={{ width: '35px', height: '35px', borderRadius: 40, objectFit: 'cover' }} className='mrd-3' />
                                                <div className='py-2 flex-1' style={{ borderBottom: '0px solid #eee' }}>
                                                    <p className="font-size-14 main-c2 weight-500" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.targetApplet?.name)}</p>
                                                    <p className="font-size-12 main-c7" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{'@' + item?.targetApplet?.hub?.username}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        )
                    })
                    }

                    {(Array.isArray(this.props.searchHistory) == false || this.props.searchHistory.length == 0) && (
                        <div className='p-3 flexcc'>
                            <p className='font-size-14 main-c7'>{translate('Nothing found')}</p>
                        </div>
                    )}

                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user, connection: state.connection })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchMain);